<p class="info-note" [innerHTML]="'CHECK_PRODUCTION_DATE_PAGE.INFO_NOTE' | translate"></p>

<ul class="rules">
  <li>{{ 'CHECK_PRODUCTION_DATE_PAGE.RULES.FIRST' | translate }}</li>
  <li>{{ 'CHECK_PRODUCTION_DATE_PAGE.RULES.SECOND' | translate }}</li>
</ul>

<p class="add-info">
  {{ 'CHECK_PRODUCTION_DATE_PAGE.ADD_INFO' | translate }}
</p>

<nz-table
  #table
  [nzData]="vinSupportData$ | async"
  [nzLoading]="loading$ | async"
  [nzBordered]="true"
  [nzSize]="'middle'"
  [nzShowPagination]="false"
>
  <thead>
  <tr>
    <th>{{ 'CHECK_PRODUCTION_DATE_PAGE.TABLE.MANUFACTURER' | translate }}</th>
    <th>{{ 'CHECK_PRODUCTION_DATE_PAGE.TABLE.ACCESS_RANGE' | translate }}</th>
    <th>{{ 'CHECK_PRODUCTION_DATE_PAGE.TABLE.VIN_MODEL' | translate }}</th>
    <th>{{ 'CHECK_PRODUCTION_DATE_PAGE.TABLE.NUMBER' | translate }}</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let row of table.data">
    <td>{{ row.manufacturer }}</td>
    <td>{{ row.range }}</td>
    <td>{{ row.model }}</td>
    <td>{{ row.digits }}</td>
  </tr>
  </tbody>
</nz-table>
